import request from '@/util/request'
import { getActivityDetail } from './booking'

// 获取教练详情（公开）
export function getCoachDetail(userId) {
  return request({
    url: `/users/${userId}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json' }
  })
}

// 获取教练的课程列表（复用已有接口）
export function getCoachCourses(teacherId) {
  return getActivityDetail(teacherId)
}

// 获取某门课程的报名学员列表（用于统计人数）
export function getCourseStudents(courseId) {
  return request({
    url: `/courseEnrollments/getCollegeByCourseId/${courseId}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json' }
  })
}

// 获取当前登录用户的个人信息（含角色）
export function getMyProfile() {
  return request({
    url: '/users/profile',
    method: 'get',
    headers: { 'Content-Type': 'application/json' }
  })
}

// 获取教练资质（含分类名称）
export function getCoachQualifications(userId) {
  return request({
    url: `/coachQualifications/user/${userId}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json' }
  })
}
